<template>
    <div class="audio-record" v-if="!isiPhone">
        <!-- loader display -->
        <svg v-if="isLoading" class="loader-icon" width="22px" height="22px" viewBox="0 0 50 50"
            style="animation: rotate 2s linear infinite;">
            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5" stroke="currentColor"
                stroke-dasharray="31.415, 31.415" stroke-linecap="round"
                style="animation: dash 1.5s ease-in-out infinite;">
            </circle>
        </svg>

        <!-- buttuns Display -->

        <button v-else id="cld-audio-button" @click="handleRecording" :disabled="notSupported"
            :style="notSupported ? disabledStyle : ''">
            <i :class="isRecording ? 'is-recording' : ''" class="material-icons-outlined mic-icon">mic</i>
        </button>
    </div>
</template>

<script>
import audioRecordStyle from "!raw-loader!@/assets/audio-record.scss";
import { apiRequest } from "@/services/api";
import store_utils from "@/store_utils";
import { customLogger } from "@/utils";
export default {
    name: 'Audio_records',
    data() {
        return {
            isLoading: false,
            isRecording: false,
            mediaRecorder: null,
            notSupported: false,
            disabledStyle: {
                cursor: 'not-allowed',
                color: 'gray',
                border: 'none',
                boxShadow: 'none',
                opacity: 0.5,
                pointerEvents: 'none',
            }
        }
    },
    computed: {
        isiPhone() {
            return /iPhone/.test(navigator.userAgent) && !/iPad/.test(navigator.userAgent) && !/iPod/.test(navigator.userAgent);
        }
    },
    mounted() {
        this.appendStyle();
    },
    methods: {
        appendStyle() {
            const iframe = document.getElementById("cleed-frame");
            const doc = iframe.contentWindow.document


            let app_style = doc.createElement("style");
            app_style.innerHTML = audioRecordStyle;
            doc.body.appendChild(app_style);
        },
        handleRecording() {
            this.isRecording = !this.isRecording;
            if (this.isRecording) {
                this.startusingBrowserMicrophone();
                setTimeout(() => {
                    this.stopRecord();
                }, 60000);
            } else {
                this.stopRecord();
            }
        },
        async getUserMedia(constraints) {
            if (window.navigator.mediaDevices) {
                return window.navigator.mediaDevices.getUserMedia(constraints);
            }
            let legacyApi =
                navigator.getUserMedia ||
                navigator.webkitGetUserMedia ||
                navigator.mozGetUserMedia ||
                navigator.msGetUserMedia;
            if (legacyApi) {
                return new Promise(function (resolve, reject) {
                    legacyApi.bind(window.navigator)(constraints, resolve, reject);
                });
            } else {
                this.notSupported = true;
                alert("user api not supported");
            }
        },
        handlerFunction(stream) {
            const audioChunks = [];
            this.mediaRecorder = new MediaRecorder(stream);
            this.mediaRecorder.ondataavailable = (e) => {
                audioChunks.push(e.data);
            };
            this.mediaRecorder.onstop = (e) => {
                const blob = new Blob(audioChunks, { type: 'audio/mp3' });
                // customLogger(blob);
                // const audio = new Audio();
                // audio.src = URL.createObjectURL(blob);
                // audio.play();
                //send audio to server multer
                this.sendAudio(blob);
            };
            this.mediaRecorder.start();
        },
        startusingBrowserMicrophone() {
            this.getUserMedia({ audio: true }).then((stream) => {
                this.handlerFunction(stream);
            }).catch((error) => {
                const At = new Date();
                this.isRecording = false;
                if (error.name === "OverconstrainedError") {
                    customLogger(
                        `Votre appareil est incompatible avec le streaming audio.`,
                    );
                    this.$store.commit("PUSH_MESSAGE", {
                        sender_type: "bot",
                        content: "Votre appareil est incompatible avec le streaming audio.",
                        typing_indicator: true,
                        sent_at: At.toISOString(),
                    });
                } else if (error.name === "NotAllowedError") {
                    customLogger(
                        "Vous n'avez pas autorisé l'utilisation du microphone, veuillez autoriser l'utilisation de cette fonctionnalité.",
                    );
                    this.$store.commit("PUSH_MESSAGE", {
                        sender_type: "bot",
                        content: "Vous n'avez pas autorisé l'utilisation du microphone, veuillez autoriser l'utilisation de cette fonctionnalité.",
                        typing_indicator: true,
                        sent_at: At.toISOString(),
                    });
                } else {
                    this.$store.commit("PUSH_MESSAGE", {
                        sender_type: "bot",
                        content: "Vous avez un problème avec votre microphone",
                        typing_indicator: true,
                        sent_at: At.toISOString(),
                    });
                }
            });
        },
        async sendAudio(data) {
            // Initialize sendDialogflow based on dialogflow_try_nbr
            let sendDialogflow = false;
            if (this.$store.state.config.details.dialogflow_try_nbr > 0) {
                this.$store.state.config.details.dialogflow_try_nbr -= 1;
                sendDialogflow = true;
            }

            // Send audio data to server
            this.isLoading = true;
            const formData = new FormData();
            formData.append('audio', data, 'audio.mp3');
            formData.append('lang', this.$store.state.user.lang);
            apiRequest().post('speechOpenai/record', formData)
                .then(({ data }) => {
                    customLogger(data);
                    this.$store.state.user.loading_indicator = true;
                    store_utils.emit_message({
                        message: data.transcription,
                        sender: "self",
                        // slack: true,
                        // dialogflow: true,
                        commit: true,
                        // should_send_dialogflow: sendDialogflow
                    });
                    this.isLoading = false;
                })
                .catch(error => {
                    customLogger("record error", error);
                    const At = new Date();
                    this.$store.commit("PUSH_MESSAGE", {
                        sender_type: "bot",
                        content: "Vous avez un problème avec votre microphone",
                        typing_indicator: true,
                        sent_at: At.toISOString(),
                    });
                    this.isLoading = false;
                });
        },
        stopRecord() {
            if (this.mediaRecorder && this.mediaRecorder.state === "recording") {
                this.mediaRecorder.stop();
                this.mediaRecorder.stream.getTracks().forEach(track => track.stop());
            }
        }
    }
}
</script>